<div class="mbm-search">
  <img class="mbm-search-icon" src="assets/icons/search.svg" alt="" aria-hidden="true">
  <input type="search" class="mbm-search-input" [placeholder]="placeholderKey() | translate"
    [value]="value()" (input)="onInput($event)">
  @if (value()) {
    <button type="button" class="mbm-search-clear" (click)="clearSearch()">
      <img src="assets/icons/close-dark.svg" alt="" aria-hidden="true">
    </button>
  }
</div>
